__turbopack_context__.v({
  "callToActionContainer": "CallToActionGroup-module-scss-module__qRdqzW__callToActionContainer",
  "callToActionItem": "CallToActionGroup-module-scss-module__qRdqzW__callToActionItem",
});
